import React, { useEffect, useState } from "react";
import { api, formatErr } from "@/lib/api";
import { PageHeader } from "@/components/Shared";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Table, TableBody, TableCell, TableHead, TableHeader, TableRow,
} from "@/components/ui/table";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogTrigger,
} from "@/components/ui/dialog";
import { Plus, Trash2 } from "lucide-react";
import { toast } from "sonner";

export default function Users() {
  const [users, setUsers] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ name: "", email: "", password: "", role: "admin" });
  const load = () => api.get("/users").then((r) => setUsers(r.data));
  useEffect(() => { load(); }, []);

  const save = async () => {
    try {
      await api.post("/users", form);
      toast.success("Utente creato"); setOpen(false);
      setForm({ name: "", email: "", password: "", role: "admin" }); load();
    } catch (e) { toast.error(formatErr(e.response?.data?.detail)); }
  };
  const del = async (id) => { if (window.confirm("Eliminare utente?")) { await api.delete(`/users/${id}`); load(); } };

  return (
    <div>
      <PageHeader title="Utenti Amministrativi" subtitle="Gestione account Admin e Super Admin.">
        <Dialog open={open} onOpenChange={setOpen}>
          <DialogTrigger asChild><Button data-testid="new-user-btn" className="bg-[#0B192C] hover:bg-[#07111E]"><Plus size={16} className="mr-1" /> Nuovo utente</Button></DialogTrigger>
          <DialogContent>
            <DialogHeader><DialogTitle>Nuovo utente</DialogTitle></DialogHeader>
            <div className="space-y-4">
              <div><Label>Nome</Label><Input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} /></div>
              <div><Label>E-mail</Label><Input value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} /></div>
              <div><Label>Password</Label><Input type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} /></div>
              <div><Label>Ruolo</Label>
                <Select value={form.role} onValueChange={(v) => setForm({ ...form, role: v })}>
                  <SelectTrigger><SelectValue /></SelectTrigger>
                  <SelectContent>
                    <SelectItem value="admin">Admin</SelectItem>
                    <SelectItem value="super_admin">Super Admin</SelectItem>
                  </SelectContent>
                </Select>
              </div>
            </div>
            <DialogFooter><Button onClick={save} data-testid="save-user-btn" className="bg-[#008C45] hover:bg-[#006B34]">Crea</Button></DialogFooter>
          </DialogContent>
        </Dialog>
      </PageHeader>
      <Card className="border-slate-200 overflow-hidden">
        <Table>
          <TableHeader className="bg-slate-50"><TableRow><TableHead>Nome</TableHead><TableHead>E-mail</TableHead><TableHead>Ruolo</TableHead><TableHead></TableHead></TableRow></TableHeader>
          <TableBody>
            {users.map((u) => (
              <TableRow key={u.id}>
                <TableCell className="font-medium">{u.name}</TableCell>
                <TableCell>{u.email}</TableCell>
                <TableCell className="capitalize">{u.role.replace("_", " ")}</TableCell>
                <TableCell><Button variant="ghost" size="icon" onClick={() => del(u.id)}><Trash2 size={15} className="text-rose-500" /></Button></TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Card>
    </div>
  );
}
